import React from 'react';
import styled from '@emotion/styled';
import { Flex, Icon, NakedButton, Text } from '@qga/roo-ui/components';

import Button from '@/components/Button/Button';
import PayWithButtonGroup from '@/components/PayWithButtonGroup';
import CalendarInput from '@/v2/components/pages/PackageView/components/CalendarInput';
import TravellersInput from '@/v2/components/pages/PackageView/components/TravellersInput';
import { useSearchPanelControls } from '@/v2/components/pages/PackageView/contexts/SearchPanelControlsContext';
import { useSearchPanelData } from '@/v2/components/pages/PackageView/contexts/SearchPanelDataContext';
import { useSearchPanelMessaging } from '@/v2/components/pages/PackageView/hooks/useSearchPanelMessaging';
import Modal from '@/v2/components/ui/Modal';
import { UI } from '@/v2/types';
import CampaignMessage from '../../../CampaignMessage';

const CloseButton = styled(NakedButton)`
  align-self: flex-end;
`;

const MobileSearchPanel = ({ campaign }: { campaign: UI.Campaign | null }) => {
  const { isMobileSearchPanelModalOpen, closeMobileSearchPanelModal } =
    useSearchPanelControls();
  const { isDisabled } = useSearchPanelData();
  const { campaignMessage, procuredOfferDatesMessage } =
    useSearchPanelMessaging({ campaign });

  if (!isMobileSearchPanelModalOpen) {
    return null;
  }

  return (
    <Modal onClose={closeMobileSearchPanelModal}>
      <Modal.Body height="100%" py="6" px="4">
        <Flex
          height="100%"
          justifyContent="space-between"
          flexDirection="column"
          gap="4"
        >
          {/* Search Inputs */}
          <Flex flexDirection="column" gap="4">
            <CloseButton
              mb="2"
              aria-label="Close"
              onClick={closeMobileSearchPanelModal}
            >
              <Icon size={32} name="close" />
            </CloseButton>
            <CampaignMessage text={campaignMessage} />
            <CalendarInput
              isMobileVariant
              campaignMessage={procuredOfferDatesMessage}
            />
            <TravellersInput isMobileVariant />
            {/* @ts-ignore - bad JS type */}
            <PayWithButtonGroup
              mt="2"
              mb="4"
              disabled={isDisabled}
              pointsPlusPayEnabled
            />
          </Flex>
          {/* Check Availability Button*/}
          <Button
            width="100%"
            py="10px"
            variant="primary"
            onClick={closeMobileSearchPanelModal}
          >
            <Text
              display="block"
              lineHeight="1.5"
              fontWeight="bold"
              fontSize="sm"
            >
              Check availability
            </Text>
          </Button>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default MobileSearchPanel;
